import * as classNames from "classnames"
import Slider from "react-slick"
import { SiteMediaData } from "../interfaces"
import { VideoSettingsData } from "widgets/commonDataObjects/interfaces"
import { SiteMedia } from "./siteMedia";
import { GalleryViewType } from "../commonComponents/base/basicMediaCarousel"
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { LabelText } from "../defenitions/ynet1280/topStory/components/labelText";
import { SiteImageData } from "widgets/interfaces"
import { MediaContentTypes } from "constants/contentTypes"

interface SiteMediaCarouselProps {
    medias: SiteMediaData[]
    height: number
    width: number
    arrowClassLeft?: string
    arrowClassRight?: string
    galleryViewOption?: GalleryViewType
    intervalTime?: number
    videoSettings?: VideoSettingsData
    title?: string
    itemLinkUrl?: string
    titlesContainerElementId?: string
    linkTarget: LinkTargetProperties
    shouldAddArticleAutoplayIndicator?: boolean
    isImageLinkable?: boolean
    articleId?: string
    galleryRatio?: string
    isDataTbLink?: boolean
    hasTextLabel?:boolean
}

interface SiteMediaCarouselState {
    currentSlide: number;
}


function PrevArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            className={classNames(className)} onClick={onClick}
            title="left"
            aria-label="left"
        />
    );
}

function NextArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            title="right"
            aria-label="right"
            className={classNames(className)}
            onClick={onClick} />
    );
}



export class SiteMediaMobileCarousel extends React.Component<SiteMediaCarouselProps, SiteMediaCarouselState>{
    public static siteScriptName = "SiteMediaMobileCarousel";
    private sliderRef: any = null;
    private autoAdvanceTimeout: any;

    constructor(props: SiteMediaCarouselProps) {
        super(props);
        this.state = { currentSlide: 0 };
    }

    private getMediaDuration = (mediaIndex: number): number => {
        const { intervalTime, medias } = this.props;
        const media = medias[mediaIndex];
        
     if (media && 
            (media.mediaType === MediaContentTypes.MEDIA_VIDEO || 
             media.mediaType === MediaContentTypes.MEDIA_LIVE) &&
            'duration' in media && 
            media.duration && 
            media.duration > 0) {
            return media.duration;
        }
        
      return intervalTime || 0;
    }

    private scheduleNextSlide = () => {
        const { intervalTime, medias } = this.props;
        
        if (!intervalTime || intervalTime <= 0 || medias.length <= 1) return;
        
        clearTimeout(this.autoAdvanceTimeout);
        
        const currentMediaDuration = this.getMediaDuration(this.state.currentSlide);
        
        this.autoAdvanceTimeout = setTimeout(() => {
            if (this.sliderRef) {
                this.sliderRef.slickNext();
            }
        }, currentMediaDuration * 1000);
    }

    private onSlideChange = (currentSlide: number) => {
        this.pauseAllVideos();
        
        this.setState({ currentSlide }, () => {
            this.playCurrentVideoIfExists();
            this.scheduleNextSlide();
        });
    }

    private pauseAllVideos = () => {
        const videoElements = document.querySelectorAll('.MediaCarousel video');
        videoElements.forEach((video: HTMLVideoElement) => {
            if (!video.paused) {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    private playCurrentVideoIfExists = () => {
        const { medias } = this.props;
        const { currentSlide } = this.state;
        const currentMedia = medias[currentSlide];
        
        if (currentMedia && 
            (currentMedia.mediaType === MediaContentTypes.MEDIA_VIDEO || 
             currentMedia.mediaType === MediaContentTypes.MEDIA_LIVE)) {
            
       setTimeout(() => {
               let activeVideo = document.querySelector('.slick-slide.slick-active .MediaCarousel video') as HTMLVideoElement;
                
                if (!activeVideo) {
                    activeVideo = document.querySelector('.slick-slide.slick-active video') as HTMLVideoElement;
                }
                
                if (!activeVideo) {
                  const allVideos = document.querySelectorAll('.MediaCarousel video');
                    if (allVideos[currentSlide]) {
                        activeVideo = allVideos[currentSlide] as HTMLVideoElement;
                    }
                }
                
                if (activeVideo && activeVideo.paused) {
                   activeVideo.currentTime = 0;
                    activeVideo.play().catch(error => {
                        console.log('Video autoplay prevented:', error);
                    });
                }
            }, 100);
        }
    }

    componentDidMount() {
        if (this.props.intervalTime && this.props.intervalTime > 0) {
            this.scheduleNextSlide();
        }
        setTimeout(() => {
            this.playCurrentVideoIfExists();
        }, 300);
    }

    componentWillUnmount() {
        clearTimeout(this.autoAdvanceTimeout);
        this.pauseAllVideos();
    }

    private getRatio = () => {
        const { galleryRatio } = this.props;

        switch (galleryRatio) {
            case "16:9":
                return "56.25%"
            case "4:3":
                return "75%"
            case "2:3":
                return "150%"
            case "1:1":
                return "100%"
            default:
                break;
        }
    }

    private hideTitlesWhenVideoPlayStarts = () => {
        if (this.props.titlesContainerElementId) {
            const titlesContainerElement = document.getElementById(this.props.titlesContainerElementId) as HTMLElement
            if (titlesContainerElement) {
                titlesContainerElement.style.visibility = "hidden";
            }
        }
    }

    public render() {
        const { medias, arrowClassRight, arrowClassLeft, height, width,hasTextLabel, 
            galleryViewOption, videoSettings, itemLinkUrl, linkTarget, shouldAddArticleAutoplayIndicator, isImageLinkable, articleId, isDataTbLink, intervalTime } = this.props
        const leftArrow = classNames("left galleryArrow", arrowClassLeft)
        const rightArrow = classNames("right galleryArrow", arrowClassRight)
       const oneItem = medias.length > 1 ? "moreThenOneItemCarousel" : ""
        const isArrow = galleryViewOption === "arrows" || galleryViewOption === "arrowsAndPaging"
        const isPaging = galleryViewOption === "paging" || galleryViewOption === "arrowsAndPaging"
        let settings = {

            infinite: true,
            autoplay: false, // We handle autoplay manually for video duration support
            dots: isPaging,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            arrows: isArrow,
            rtl: false,
            prevArrow: <PrevArrow props={{ className: leftArrow }} />,
            nextArrow: <NextArrow props={{ className: rightArrow }} />,
            beforeChange: (current: number, next: number) => {
                this.pauseAllVideos();
            },
            afterChange: this.onSlideChange

        }
        return (
            <Slider {...settings} ref={slider => this.sliderRef = slider}>
                {medias.map((media, i) =>
                    <div className={`MediaCarousel ${oneItem}`} style={{ height, width }} key={i} >
                        <div className="mediaItems" >
                      {hasTextLabel &&  <LabelText className={"mediaItemLabel"} 
                    labelText={(media as SiteImageData).labelText} mediaIconPlace={(media as SiteImageData).textPlace} onLabelTextChange={()=>null} />}
                            <SiteMedia
                                itemLinkUrl={itemLinkUrl}
                                linkTarget={linkTarget}
                                shouldAddArticleAutoplayIndicator={shouldAddArticleAutoplayIndicator}
                                onPlayStarted={this.hideTitlesWhenVideoPlayStarts}
                                isImageLinkable={isImageLinkable}
                                data={media}
                                height={height}
                                width={width}
                                key={media.url}
                                isDataTbLink={isDataTbLink}
                                videoSettings={videoSettings}
                                allMedias={medias}
                                articleId={articleId} />

                        </div>


                    </div>)}
            </Slider>
        )
    }
}

